import Component from '../abstracts/Component';
import { TweenLite, CSSPlugin } from 'gsap';

export default class BackdropComponent extends Component {

  static get SELECTORS() {
    return {
      main: '.js-backdrop'
    };
  }

  static get EVENTS() {
    return {
      show: 'backdrop:show',
      hide: 'backdrop:hide',
      hidden: 'backdrop:hidden',
      shown: 'backdrop:shown',
      main: 'click.bd keydown.bd'
    };
  }

  static get CLASSES() {
    return {
      in: 'in',
      visible: 'visible',
      dark: 'dark',
    }
  }

  constructor() {
    super();
    this.selector = BackdropComponent.SELECTORS;
    this.classes = BackdropComponent.CLASSES;
    this.window = $(window);
    this.inModal = false;
  }

  animate(classes, show, zIndex) {
    let el = document.querySelector(this.selector.main);

    if (this.inModal) {
      el = document.querySelector(`${this.selector.main}[data-in-modal="true"]`);
    }

    el.style.zIndex = zIndex ? zIndex : '';
    // let $el = $(this.selector.main);
    if (classes) {
      el.setAttribute('data-backdrop-classes', '');
      el.setAttribute('data-backdrop-classes', classes);
      classes.split(',').forEach(c => el.classList.add(c));
    } else {
      let dataClasses = el.getAttribute('data-backdrop-classes');
      if (dataClasses) dataClasses.split(',').forEach(c => el.classList.remove(c));
    }

    if (show) {
      el.classList.add(`${this.classes.visible}`);
      return this.$customEvents.BACKDROP_EVENTS.shown;
    } else {
      el.classList.remove(this.classes.visible);
      return this.$customEvents.BACKDROP_EVENTS.hidden;

    }
  }

  bindEvents() {
    let el = document.querySelector(this.selector.main);
    // show event
    this.$on(this.$customEvents.BACKDROP_EVENTS.show, ({payload}) => {

      this.inModal =  payload && payload.inModal ? true : false;

      const classes = payload && payload.classes ? payload.classes : '';
      const zIndex = payload && payload.zIndex ? payload.zIndex : '';
      this.$emit(this.animate(classes, true, zIndex));
    });

    // hide event
    this.$on(this.$customEvents.BACKDROP_EVENTS.hide, ({payload}) => {
      this.$emit(this.animate('', false, ''));
    });

    // backdrop click and keydown events
    this.$on(this.$customEvents.KEYBOARD_EVENTS.escape, ({payload}) => {
      if (el.classList.contains(this.classes.visible) > -1) {
        this.$emit(this.animate('', false));
      }
    });


    this.$on('click.backdrop touchend.backdrop', ({payload}) => {
      if (el.classList.contains(this.classes.visible) > -1) {
        this.$emit(this.animate('', false));
      }
      this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
    }, 'body', this.selector.main);

  }

  render() {
    this.bindEvents();
  }
}
